<template>
  <IziCard class="card-login">
    <Toolbar>
      <template #left>
        <Logo />
        <slot name="leftHeader"></slot>
      </template>
      <template #right>
        <EnterPin />
      </template>
    </Toolbar>
  </IziCard>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import LeftPanel from "@/components/leftPanel/LeftPanel.vue";
import RightPanel from "@/components/rightPanel/RightPanel.vue";
@Options({
  components: {
    LeftPanel,
    RightPanel
  }
})
export default class Header extends Vue {
  Pin = "";
}
</script>

<style lang="scss">
.card-login {
  height: 99%;
}
</style>
